import React from 'react';

// Add this component
// FAQ Component
const FAQSection = () => {
  return (
    <div className="bg-white py-8 px-4 sm:px-6 lg:px-8 overflow-auto">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl font-extrabold text-gray-900 mb-8 text-center">
          Frequently Asked Questions
        </h2>
        
        <div className="space-y-8">
          {/* FAQ Items */}
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">More Resources?</h3>
            <ul className='text-sm font-bold text-blue-300'>
              <li className="mb-1"><a href="https://www.findmyschool.vic.gov.au/" target="_blank" rel="noopener noreferrer">Official Find My School Website</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">What are school zones and why do they matter?</h3>
            <p className="text-gray-600">
              School zones (also called catchment areas) are geographic boundaries that determine which public schools your child can attend based on your residential address. 
              Living within a zone guarantees your child's enrollment eligibility at that school, which is especially important for high-performing or popular schools.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">How accurate is the school ranking data?</h3>
            <p className="text-gray-600">
              Our rankings are based on VCE performance data published by the Victorian Department of Education. Schools are ranked according to their median VCE study scores. 
              While academic performance is important, it's just one factor to consider when choosing a school for your child.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">How recent is the property price data?</h3>
            <p className="text-gray-600">
              The property price data comes from the most recent available real estate statistics for each suburb, typically from the past 12 months. 
              Property prices are shown as median values for each suburb, and catchment areas often span multiple suburbs.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Can I use this data for investment decisions?</h3>
            <p className="text-gray-600">
              This tool provides general information for research purposes. While many property investors consider school zones in their purchase decisions, we recommend consulting with 
              real estate professionals and financial advisors before making investment decisions based on this data.
            </p>
          </div>
          
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">Do school zones ever change?</h3>
            <p className="text-gray-600">
              Yes, school zones can change over time. The Department of Education periodically reviews and updates school catchment areas based on factors like population changes and school capacity. 
              Always verify the current school zone boundaries through the official Find My School website before making property decisions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
  
  export default FAQSection;
